
// import img1 from "../assets/mascot-service-1.png";
// import img2 from "../assets/mascot-service-2.png";
// import img3 from "../assets/mascot-service-3.png";

import logo2 from "../assets/rend1.png";
import useFadeInOnScroll from "../useFadeInOnScroll";

const WhatDoWeDo = () => {
    useFadeInOnScroll();
    //  style={{letterSpacing:"0.025px"}}
    return (
        <div className='WhatWeDo' id="services">
            <h1  style={{letterSpacing:"1px"}} data-translate="WhatWeDo1" className='fadeOnScroll'>Turning ideas into playful worlds your users will love to explore.</h1>
            <div className='cardContainer'>

                <div className="card fadeOnScroll">
                    <h2 data-translate="wwd1" style={{letterSpacing:"1px"}}>Razvoj interaktivnih iger</h2>
                    <p data-translate="wwd2">We design and develop fully custom games that are built to engage and entertain.
                        Whether you need a fun interactive project for your brand, a training tool for teams or a
                        learning experience for students.</p>
                    {/* <img src={logo2} alt="img" /> */}
                    <div>
                        <i className="fas fa-gamepad"></i>
                    </div>
                </div>

                <div className="card fadeOnScroll">
                    <h2 data-translate="wwd3" style={{letterSpacing:"1px"}}>Promocijske in blagovne znamke igre</h2>
                    <p data-translate="wwd4">We create custom games that showcase your brand, product,
                        or event in a playful and memorable way. Engaging, interactive,
                        and shareable, our games turn marketing into an experience people
                        actually want to play.</p>
                    {/* <img src={logo2} alt="img" /> */}
                    <div>
                        <i className="fas fa-bullhorn"></i>
                    </div>
                    
                </div>
                <div className="card fadeOnScroll">
                    <h2 data-translate="wwd5" style={{letterSpacing:"1px"}}>Razvoj igraficiranih aplikacij</h2>
                    <p data-translate="wwd6">We design and build fully custom apps with game-like elements that make learning,
                        training, or engagement fun and rewarding. Your goals, audience, and
                        content shape an interactive experience that users actually want to use.</p>
                    {/* <img src={logo2} alt="img" /> */}
                    <div>
                        <i className="fas fa-mobile-alt"></i>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WhatDoWeDo